module.exports = __webpack_public_path__ + "media/images/iconInfo__inFrontOfAccent--dark-74f4c80d7260bab8dcfcfa3a1ce1cc4f.png";